import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const iconMap: Record<string, string> = {
    'Shoes': 'ri-footprint-line',
    'Hoodies/Sweaters': 'ri-t-shirt-line',
    'T-Shirts': 'ri-t-shirt-line',
    'Jackets': 'ri-honor-of-kings-line',
    'Pants/Shorts': 'ri-pantone-line',
    'Headwear': 'ri-customer-service-2-line',
    'Sets': 'ri-stack-line',
    'Underwear/Underpants': 'ri-shirt-line',
    'Jersey': 'ri-t-shirt-line',
    'Accessories': 'ri-glasses-line',
    'Bags': 'ri-briefcase-line',
    'Belts': 'ri-link',
    'Perfumes': 'ri-drop-line',
    'Other Stuff': 'ri-more-line',
  };

  return (
    <section id="categories" className="py-16 md:py-24 px-4 md:px-6 scroll-mt-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
            Browse Categories
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4 text-balance">
            Popular Vigorbuy Spreadsheet Categories
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            Explore organized <strong>vigorbuy spreadsheet links</strong> across every category. Click any category to browse products on our main website.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 hover:bg-accent-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${iconMap[cat.name] || 'ri-folders-line'} text-accent-600 text-lg`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-700 text-center leading-tight whitespace-nowrap">{cat.name}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}